"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var undoActions = require("owa-mail-undo");
var datapoints_1 = require("./datapoints");
var flagItemService_1 = require("owa-mail-store/lib/services/flagItemService");
var Store_1 = require("owa-mail-list-store/lib/store/Store");
var setRowsFlagStateHelper_1 = require("./helpers/setRowsFlagStateHelper");
var owa_mail_strings_1 = require("owa-strings/owa-mail-strings");
var legacy_1 = require("satcheljs/lib/legacy");
var owa_mail_list_store_1 = require("owa-mail-list-store");
var owa_service_error_1 = require("owa-service-error");
var owa_mail_actions_1 = require("owa-mail-actions");
var owa_mail_store_1 = require("owa-mail-store");
var flagItemsStoreUpdate_1 = require("owa-mail-actions/lib/triage/flagItemsStoreUpdate");
var SetItemsFlagStateActionName = 'setItemsFlagState';
var setItemsFlagStateInternal = legacy_1.action(SetItemsFlagStateActionName, datapoints_1.default.setItemsFlagStateDatapoint)(function setItemsFlagStateInternal(itemIds, instrumentationContexts, flagStatusToApply, parentFolderId) {
    undoActions.clearLastUndoableAction();
    var itemContexts = itemIds.map(function (itemIdValue) {
        var item = owa_mail_store_1.selectMailStoreItemById(itemIdValue);
        return {
            itemId: itemIdValue,
            conversationId: item.ConversationId.Id,
        };
    });
    owa_service_error_1.handleServiceError(SetItemsFlagStateActionName, flagStatusToApply == 'Flagged'
        ? owa_mail_strings_1.default.errorMarkingItemAsFlag
        : owa_mail_strings_1.default.errorMarkingItemAsUnFlag, function () {
        // Dispatch action to update the store state
        flagItemsStoreUpdate_1.default(itemContexts, flagStatusToApply, parentFolderId);
        var instrumentationFlag;
        switch (flagStatusToApply) {
            case 'Flagged':
                instrumentationFlag = 'Flag';
                break;
            case 'NotFlagged':
                instrumentationFlag = 'FlagCleared';
                break;
            case 'Complete':
                instrumentationFlag = 'FlagComplete';
                break;
        }
        owa_mail_actions_1.userMailInteractionAction(instrumentationFlag, instrumentationContexts);
        return flagItemService_1.default(itemIds, flagStatusToApply);
    });
});
/**
 * Set the specified flag state on a collection of items in listview table
 * @param itemRowKeys - the item row keys
 * @param tableViewId - the table view the conversations are in
 * @param flagType - the specified flag type to set
 */
function setItemsFlagStateFromTable(itemRowKeys, instrumentationContexts, tableViewId, flagStatusToApply) {
    var tableView = Store_1.default.tableViews.get(tableViewId);
    setRowsFlagStateHelper_1.default(itemRowKeys, tableViewId, flagStatusToApply, function (rowKeys, flagStatusToApply) {
        var rowIdStrings = owa_mail_list_store_1.getRowIdsFromRowKeys(rowKeys, tableViewId);
        setItemsFlagStateInternal(rowIdStrings, instrumentationContexts, flagStatusToApply, tableView.tableQuery.folderId);
    });
}
exports.setItemsFlagStateFromTable = setItemsFlagStateFromTable;
function setItemsFlagStateFromReadingPane(itemIds, instrumentationContexts, flagStatusToApply, parentFolderId) {
    // Filter by existence in the item cache
    var filteredItemIds = itemIds.filter(function (itemId) { return !!owa_mail_store_1.selectMailStoreItemById(itemId); });
    if (filteredItemIds.length > 0) {
        setItemsFlagStateInternal(filteredItemIds, instrumentationContexts, flagStatusToApply, parentFolderId);
    }
}
exports.setItemsFlagStateFromReadingPane = setItemsFlagStateFromReadingPane;
//# sourceMappingURL=setItemsFlagState.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/setItemsFlagState.js
// module id = 3817
// module chunks = 62